var _rect, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path2, _circle, _rect2, _circle2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 226,
    viewBox: "0 0 604 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 455,
    height: 226,
    transform: "translate(74.5)",
    fill: "#F6F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.184 196.115C425.668 196.45 424.979 196.303 424.644 195.787L418.71 186.647C418.375 186.131 418.521 185.441 419.037 185.106C419.553 184.771 420.243 184.918 420.578 185.434L426.512 194.575C426.847 195.09 426.7 195.78 426.184 196.115ZM418.647 194.512C418.131 194.847 417.441 194.7 417.106 194.184C416.771 193.668 416.918 192.979 417.434 192.644L426.575 186.71C427.09 186.375 427.78 186.521 428.115 187.037C428.45 187.553 428.303 188.243 427.787 188.578L418.647 194.512Z",
    fill: "#FF6B00",
    fillOpacity: 0.690196
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 217.5,
    x2: 504.5,
    y2: 217.5,
    stroke: "url(#paint0_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 188.5,
    x2: 558.5,
    y2: 188.5,
    stroke: "url(#paint1_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 159.5,
    x2: 585.5,
    y2: 159.5,
    stroke: "url(#paint2_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 130.5,
    x2: 602.5,
    y2: 130.5,
    stroke: "url(#paint3_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 102.5,
    x2: 602.5,
    y2: 102.5,
    stroke: "url(#paint4_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 73.5,
    x2: 585.5,
    y2: 73.5,
    stroke: "url(#paint5_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 44.5,
    x2: 558.5,
    y2: 44.5,
    stroke: "url(#paint6_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 15.5,
    x2: 504.5,
    y2: 15.5,
    stroke: "url(#paint7_linear_7768_55883)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.062 46.625C192.447 46.625 191.949 46.1264 191.949 45.5114V34.6136C191.949 33.9986 192.447 33.5 193.062 33.5C193.678 33.5 194.176 33.9986 194.176 34.6136V45.5114C194.176 46.1264 193.678 46.625 193.062 46.625ZM187.614 41.1761C186.999 41.1761 186.5 40.6775 186.5 40.0625C186.5 39.4475 186.999 38.9489 187.614 38.9489H198.511C199.126 38.9489 199.625 39.4475 199.625 40.0625C199.625 40.6775 199.126 41.1761 198.511 41.1761H187.614Z",
    fill: "#FF6B00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 23,
    r: 5,
    stroke: "#FF6B00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 9.5,
    width: 212,
    height: 212,
    rx: 106,
    fill: "#FCEBE1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 202,
    r: 5.5,
    fill: "#DA6420"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_7768_55883)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.314,
    y: 65.9463,
    width: 133.675,
    height: 133.675,
    rx: 16,
    transform: "rotate(-13.0306 224.314 65.9463)",
    fill: "url(#paint8_linear_7768_55883)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.762 78.3359H308.81M301.786 120.48L312.322 109.944M329.882 120.48C329.882 135.997 317.303 148.576 301.786 148.576C286.269 148.576 273.69 135.997 273.69 120.48C273.69 104.963 286.269 92.3839 301.786 92.3839C317.303 92.3839 329.882 104.963 329.882 120.48Z",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_7768_55883",
    x: 211.507,
    y: 26.998,
    width: 185.988,
    height: 185.989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7768_55883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7768_55883",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_7768_55883"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_7768_55883",
    result: "effect3_innerShadow_7768_55883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7768_55883",
    x1: 98,
    y1: 219.5,
    x2: 506,
    y2: 219.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7768_55883",
    x1: 44,
    y1: 190.5,
    x2: 560,
    y2: 190.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7768_55883",
    x1: 17,
    y1: 161.5,
    x2: 587,
    y2: 161.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7768_55883",
    x1: 0,
    y1: 132.5,
    x2: 604,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7768_55883",
    x1: 0,
    y1: 104.5,
    x2: 604,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7768_55883",
    x1: 17,
    y1: 75.5,
    x2: 587,
    y2: 75.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7768_55883",
    x1: 44,
    y1: 46.5,
    x2: 560,
    y2: 46.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7768_55883",
    x1: 98,
    y1: 17.5,
    x2: 506,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7768_55883",
    x1: 291.152,
    y1: 65.9463,
    x2: 291.152,
    y2: 199.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-color-text)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/comingSoon.2759770c69e659bed53d0c20a1d520fa.svg";
export { ForwardRef as ReactComponent };